"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.clamp = void 0;
var clamp = exports.clamp = function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
};
var _default = exports.default = clamp;